(() => {
  // Reviewsio Popup Component
  if (!customElements.get('reviewsio-popup')) {
    class ReviewsioPopup extends HTMLElement {
      constructor() {
        super();
        this.scrollY = 0;
        this.isOpen = false;
      }

      connectedCallback() {
        this.closeButton = this.querySelector('[data-popup-close]');
        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => this.hide());
        }

        this.addEventListener('click', (e) => {
          if (e.target === this) {
            this.hide();
          }
        });

        this.addEventListener('keyup', (e) => {
          if (e.code === 'Escape' && this.isOpen) {
            this.hide();
          }
        });
      }

      show() {
        if (this.isOpen) return;

        document.body.classList.add('modal-open');
        this.setAttribute('open', '');
        this.isOpen = true;
      }

      hide() {
        if (!this.isOpen) return;

        this.removeAttribute('open');
        this.isOpen = false;
        document.body.classList.remove('modal-open');
      }
    }

    customElements.define('reviewsio-popup', ReviewsioPopup);
  }

  // Reviewsio Popup Button Component
  if (!customElements.get('reviewsio-popup-button')) {
    class ReviewsioPopupButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;

        const modalId = this.dataset.modal;
        if (!modalId) return;

        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const popup = document.querySelector(modalId);
          if (popup && popup.show) {
            popup.show();
          }
        });
      }
    }

    customElements.define('reviewsio-popup-button', ReviewsioPopupButton);
  }
})();
